'use strict';
(function () {
  angular.module('pentaApp').factory('customInqueryStatistics.resource', service);

  service.$inject = ['$resource'];
  function service($resource) {
    return $resource('/progressiveApp/api/customInqueryStatistics', null, { queryNoPaginate: { isArray: true, cache: false } });
  }
})();
